import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-sage/30 bg-brand-cream text-center text-brand-text-muted text-sm" data-id="element-56">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-57">
        <p className="text-brand-forest font-bold text-lg" data-id="element-58">
          THE THYROID RESET COOKBOOK™
        </p>
        <p data-id="element-59">
          60 delicious thyroid-friendly recipes to support your energy,
          metabolism and hormonal balance.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-60">
          <a href="#" className="hover:text-brand-sage" data-id="element-61">
            Terms & Conditions
          </a>
          <span data-id="element-62">|</span>
          <a href="#" className="hover:text-brand-sage" data-id="element-63">
            Privacy Policy
          </a>
        </div>
        <p className="text-xs" data-id="element-64">
          © {new Date().getFullYear()} The Thyroid Reset Cookbook™. All rights
          reserved.
        </p>
      </div>
    </footer>;
}